import * as React from "react"

import Link from "../Link"

interface Props {
    attributes: Record<string, string>
    label: string
}

export const CreatePerson = ({ attributes, label }: Props): JSX.Element => {
    const href = "config/createperson"
    return <Link attributes={attributes} label={label} href={href} />
}

export default CreatePerson
